import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { SelectOption } from 'components/dropdown/Dropdown';
import { MultiSelectSearchListWithLinks } from 'components/helpers/CustomFieldRenderers/SearchListFieldRenderer/MultiSelectSearchListWithLinks';
import { EditSingleSelectRadio } from 'components/helpers/CustomFieldRenderers/SingleSelectRadioWithConditional.tsx/SingleMultiSelectFieldRenderer';


interface ContactImportFormProps {
  isRedirected?: boolean;
  parentSelectedId: number | undefined;
}

const ContactImportForm: React.FC<ContactImportFormProps> = ({
  isRedirected,
  parentSelectedId,
}) => {
  const formik = useFormikContext<any>();

  useEffect(() => {
    if (isRedirected) {
      formik.setFieldValue("contactAccessTypesId", 1001);
    }
  }, [isRedirected]);

  return (
    <>
      {!isRedirected && (
        <EditSingleSelectRadio
          name={"contactTypesId"}
          label={"Gloabl / Site / Project"}
          dataSource={"contactTypesIds"}
          editDisable={parentSelectedId ? true : false}
        />
      )}
      {formik.values.contactTypesIds
        ?.find(
          (type: SelectOption) => type.value === formik.values.contactTypesId
        )
        ?.label.trim()
        .toLowerCase() === "site" && (
          <div className="FormBox FormSideBySide">
            <MultiSelectSearchListWithLinks
              name={"sitesID"}
              key={"sitesID"}
              label={"Sites"}
              dataSource={"siteData"}
              singleSelect={true}
            />
          </div>
        )}
      {formik.values.contactTypesIds
        ?.find(
          (type: SelectOption) => type.value === formik.values.contactTypesId
        )
        ?.label.trim()
        .toLowerCase() === "project" && (
          <div className="FormBox FormSideBySide">
            <MultiSelectSearchListWithLinks
              name={"projectsID"}
              key={"projectsID"}
              label={"Projects"}
              dataSource={"projectData"}
              singleSelect={true}
              editDisable={parentSelectedId ? true : false}
            />
          </div>
        )}
    </>
  );
};

export default ContactImportForm;